import { render, staticRenderFns } from "./portChange.vue?vue&type=template&id=780b3fcf&scoped=true"
import script from "./portChange.vue?vue&type=script&lang=js"
export * from "./portChange.vue?vue&type=script&lang=js"
import style0 from "./portChange.vue?vue&type=style&index=0&id=780b3fcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780b3fcf",
  null
  
)

export default component.exports